import React from 'react';
import { createIcon } from './create-icon';
import './icon-info-filled.scss';

export const IconInfoFilled = createIcon(<div className="icon-info-filled" />);
